
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 11","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.624.121A5.194 5.194 0 0 0 .432 5.313a5.194 5.194 0 0 0 5.192 5.193 5.193 5.193 0 0 0 5.192-5.193A5.194 5.194 0 0 0 5.624.121Z","fill":"#fff"}}),_c('path',{attrs:{"d":"M5.624 1.213a4.101 4.101 0 0 0 0 8.2 4.101 4.101 0 0 0 0-8.2Z","fill":"#d9531e"}})])
          )
        }
      }
    